import { createElement, type ComponentProps } from 'react';

import { chakra } from '@plurall/elo-v3';

import { clsx } from '@/lib/formatters/classNames';

import {
  navItemRecipe,
  navLoadingItemRecipe,
  navSectionRecipe,
  navSectionTitleRecipe,
  navSeparatorRecipe,
} from './local-navigation-section-recipe';

export const NavSectionFactory = chakra('section', navSectionRecipe);
export const NavSectionTitleFactory = chakra('h3', navSectionTitleRecipe);
export const BaseNavSeparatorWrapperFactory = chakra('hr', navSeparatorRecipe);

export const NavItemFactory = chakra('div', navItemRecipe);
export const BaseNavLoadingItemFactory = chakra('li', navLoadingItemRecipe);

export type NavLoadingItemFactoryProps = ComponentProps<typeof BaseNavLoadingItemFactory>;

export function NavLoadingItemFactory({ className, ...props }: NavLoadingItemFactoryProps) {
  return createElement(BaseNavLoadingItemFactory, {
    ...props,
    className: clsx(className, 'local-navigation__item', 'local-navigation__item--loading'),
  });
}
